import React from 'react';
import '@ant-design/compatible/assets/index.css';
import { Col, Form, FormInstance, Row } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import TextArea from 'antd/lib/input/TextArea';

import ParListSelect from 'components/ParListSelect/ParListSelect';
import Checkbox from 'components/Checkbox/Checkbox';
import { shouldUpdateCompare } from 'utils/utils2';
import Text from 'antd/lib/typography/Text';

export type TabParListActivationProps = {
  form?: FormInstance;
  objectid?: number;
  parcode?:string;
  parvalue?:string;
  parvalueparent?:string;
  objectreference?:string;
  entityName?:string;
};

const TabParListActivation = ({ objectid, form,parcode,parvalue,parvalueparent,entityName }: TabParListActivationProps) => {
 

  form?.setFieldsValue({
    event:'tabParListActivation',
    parcode:parcode,
    newparvalue:parvalue,

  });

  return (
    <DF.Provider pagcode="TabParListActivation">
      <Row style={{ marginTop: '20px' }}>
          <Col span={24}>
            <Row gutter={32}>
                <FormInput col name="valueToActivate" xl={12}>
                    <Text>{entityName}</Text>
                  </FormInput>

              <FormInput col name="flagreplace2" xl={4} valuePropName='checked'>
                <Checkbox onChange={e=>{
                  form?.setFieldsValue({flagreplace:e.target.checked});}} comcode='flagreplace'
                />
              </FormInput>
              <Form.Item shouldUpdate={shouldUpdateCompare('flagreplace')} noStyle>
            {({ getFieldValue }) => {
              const flag=getFieldValue('flagreplace');
              if (flag===true) return (
                  <>
                  <FormInput col name="parvalue" xl={12} rules={[{ required: flag===true?true:false }]}>
                    <ParListSelect parcode={parcode??''} />
                  </FormInput>

                  <FormInput col name="reason" xl={8}>
                    <ParListSelect parcode='ATTRREAS' allowAddValue/>
                  </FormInput>
                  </>
              )
            }}
            </Form.Item>
            </Row>
            <Row gutter={30}>
              <Col span={24}>
                <FormInput name="comment" rules={[{ required: true }]}>
                  <TextArea maxLength={255} rows={5} cols={300} />
                </FormInput>
              </Col>
            </Row>
          </Col>
      </Row>
    </DF.Provider>
  );
};
export default TabParListActivation;
